module.exports = __webpack_public_path__ + "static/media/Burnout.a86a6f2a.svg";